
import React from "react";

const PostLoading = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <p>Loading post...</p>
    </div>
  );
};

export default PostLoading;
